import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import PersonSummary from '../components/PersonSummary';

const ComposablePersonSummary = ({ persons }) => {
  if (!persons.length && !persons[0]) {
    return null;
  }
  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="span 10"
      columnStartLg="3"
      columnEndLg="11"
    >
      {/* Because persons can have more than 1 person. We decided to always take the 1st in the array to display. */}
      <PersonSummary {...persons[0]} />
    </GridItem>
  );
};

ComposablePersonSummary.defaultProps = {
  persons: [],
};

ComposablePersonSummary.propTypes = {
  persons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      slug: PropTypes.string.isRequired,
      firstCharacter: PropTypes.string.isRequired,
      photo: PropTypes.shape({
        altText: PropTypes.string,
        url: PropTypes.string,
      }),
    })
  ),
};

export default ComposablePersonSummary;
